export enum TournamentStatus {
  Open = 1,
  ReadyToDraw = 2,
  Drawn = 3,
  Completed = 4,
  Cancelled = 5,
}

export enum TournamentLevel {
  Beginner = 1,
  Intermediate = 2,
  Advanced = 3,
  Competitive = 4,
  Open = 5,
}

export enum TournamentTeamFormat {
  Pairs = 1,
  Individuals = 2,
}

export interface Tournament {
  id: number;
  name: string;
  club_id: number;
  club_name: string;
  start_date: string;
  registration_deadline: string;
  max_teams: number;
  admission_price: number;
  level: TournamentLevel;
  team_format: TournamentTeamFormat;
  prize_description: string | null;
  status: TournamentStatus;
  created_by_user_id: number;
  created_at: string;
  court_ids: number[];
  registered_teams_count: number;
}

export interface CreateTournamentRequest {
  name: string;
  club_id: number;
  start_date: string;
  registration_deadline: string;
  max_teams: number;
  admission_price: number;
  level: TournamentLevel;
  team_format: TournamentTeamFormat;
  prize_description?: string;
  court_ids: number[];
}

export interface TournamentListFilters {
  clubId?: number;
  status?: TournamentStatus;
  upcomingOnly?: boolean;
}

export enum TournamentRegistrationStatus {
  PendingPartner = 1,
  Confirmed = 2,
  Cancelled = 3,
  Rejected = 4,
}

export interface TournamentRegistration {
  id: number;
  tournament_id: number;
  player_id: number;
  partner_id: number | null;
  status: TournamentRegistrationStatus;
  created_at: string;
}

export interface MyTournament {
  tournament: Tournament;
  my_registration: TournamentRegistration;
  is_partner: boolean;
}

export interface RegisterRequest {
  partner_id?: number;
}

export interface BracketMatch {
  id: number;
  round: number;
  slot: number;
  team_a_id: number | null;
  team_b_id: number | null;
  team_a_name: string | null;
  team_b_name: string | null;
  winner_team_id: number | null;
  scores_json: string | null;
  is_walkover: boolean;
  court_id: number | null;
  scheduled_at: string | null;
  next_match_id: number | null;
  next_match_slot: number | null;
}

export interface Bracket {
  tournament_id: number;
  status: TournamentStatus;
  winner_team_id: number | null;
  matches: BracketMatch[];
}

export interface SubmitResultRequest {
  winner_team_id: number;
  scores_json?: string;
  is_walkover: boolean;
}
